<template>
	<TheBox :title="displayedCaseTitle(decision)" :titleLevel="3" :insideTable="true">
		<template #boxheaderRight>
			<div class="has-status" :class="`has-status--${$getStateColor('decision', decision.decisionState)}`">
				{{ $getStateFullLabel('decision', decision.decisionState) }}
			</div>
		</template>

		<el-row class="flex flex-grow flex--justifyspacebetween">
			<span>
				{{ decision.role.name }}
			</span>
			<span>
				{{
					decision.decisionType === SendCaseType.SmallSenate
						? $formatDate(displayedPreVoteEndDate(decision))
						: $formatDate(displayedVoteEndDate(decision))
				}}
			</span>
		</el-row>

		<div class="button-panel">
			<TheButton type="default" @buttonclick="goToDetailPage(decision)">Details zur Entscheidung</TheButton>
		</div>
	</TheBox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheBox from '../TheBox.vue';
import TheButton from '../TheButton.vue';
import { DecisionResponse, SendCaseType } from '../../types/types';

export default defineComponent({
	name: 'BoxDecision',
	data() {
		return {
			SendCaseType,
		};
	},
	props: {
		decision: {
			type: Object,
			required: true,
		},
		caseTitle: {
			type: String,
			default: '',
		},
		preVoteEndDate: {
			type: String,
			default: '',
		},
		voteEndDate: {
			type: String,
			default: '',
		},
	},
	components: {
		TheBox,
		TheButton,
	},
	computed: {},
	methods: {
		goToDetailPage(row: DecisionResponse) {
			this.$router.push({ name: 'EntscheidungDetail', params: { id: String(row.id) } });
		},
		displayedCaseTitle(row) {
			return this.caseTitle ? this.caseTitle : row.case.title;
		},
		displayedPreVoteEndDate(row) {
			return this.preVoteEndDate ? this.preVoteEndDate : row.case?.preVoteEndDate;
		},
		displayedVoteEndDate(row) {
			return this.voteEndDate ? this.voteEndDate : row.case?.voteEndDate;
		},
	},
	mounted() {},
});
</script>

<style lang="scss"></style>
